import * as React from 'react';
import { clsx } from 'clsx';

import * as styles from './OfferDesktopSkeleton.css';

export const OfferDesktopSkeleton: React.FC = () => {
  return (
    <div className={styles['container']}>
      <div className={clsx(styles['skeleton'], styles['image'])} />
      <div className={styles['info']}>
        <div className={clsx(styles['skeleton'], styles['text'], styles['v1'])} />
        <div className={styles['texts']}>
          <div className={clsx(styles['skeleton'], styles['text'], styles['v2'])} />
          <div className={clsx(styles['skeleton'], styles['text'], styles['v3'])} />
          <div className={clsx(styles['skeleton'], styles['text'], styles['v4'])} />
          <div className={clsx(styles['skeleton'], styles['text'], styles['v5'])} />
        </div>
      </div>
    </div>
  );
};
